export default function (context,facetResults){
    const filters = []
    
    const persistFacetSelection = function(selectedFilters,facet,filter){
        return !!selectedFilters.filter(selectedFilter => selectedFilter.name === filter && selectedFilter.value === facet.key).length
    }

    const buildFacetList = (list,filter) => {
        const facets = []
        const selectedFilters = context.getters.listSelectedFacets
        
        for(let facet in list.facets){
            const facetData = list.facets[facet]
            facets.push({
                displayName: facetData.displayName,
                name: facetData.key,
                selected: persistFacetSelection(selectedFilters,facetData,filter),
                count: facetData.count
            })
        }

        return facets
    }

    for(let filter in facetResults){
        filters.push({
            displayName: facetResults[filter].displayName,
            name: filter,
            facets: buildFacetList(facetResults[filter],filter)
        })
    }

    context.commit('set_filters',filters)

    history.replaceState(null,'',context.getters.browserUrlString)
}